import WhatsAppChannelCard, { type WhatsappEmbeddedSignupConfig } from '@/frontend/components/DigitalWorkers/WhatsAppChannelCard'
import DiscordChannelCard from '@/frontend/components/DigitalWorkers/DiscordChannelCard'
import TelegramChannelCard from '@/frontend/components/DigitalWorkers/TelegramChannelCard'
import SlackComingSoonCard from '@/frontend/components/DigitalWorkers/SlackComingSoonCard'
import CodexSlackCard from '@/frontend/components/DigitalWorkers/CodexSlackCard'
import type { DigitalWorkerDetail, DiscordBot } from '@/frontend/pages/Dashboard/DigitalWorkers/types'

interface Props {
  worker: DigitalWorkerDetail
  whatsappBusinessAvailable: boolean
  whatsappEmbeddedSignup: WhatsappEmbeddedSignupConfig
  discordBots: DiscordBot[]
  canManage: boolean
}

export default function ChannelsGrid({ worker, whatsappBusinessAvailable, whatsappEmbeddedSignup, discordBots, canManage }: Props) {
  const gatewayChannels = worker.runtime_capabilities.gateway_channels
  const whatsappCloud = worker.runtime_capabilities.whatsapp_cloud
  const telegram = worker.runtime_capabilities.telegram
  const status = gatewayChannels.supported ? gatewayChannels : whatsappCloud.supported ? whatsappCloud : telegram.supported ? telegram : gatewayChannels
  return (
    // DS novo: seção plana (borda + radius-12, sem sombra) igual a
    // SubscriptionStatusCard/Allowlist — não mais o Card elevado.
    <section className="space-y-4 rounded-xl border border-border bg-card p-5">
      <h2 className="text-[14px] font-semibold text-foreground">Canais de comunicação</h2>
      <p role="status" className="text-sm text-muted-foreground">{status.reason}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {(whatsappCloud.supported || worker.whatsapp_provider === 'business') && <WhatsAppChannelCard
          worker={worker}
          whatsapp_business_available={whatsappBusinessAvailable}
          whatsapp_embedded_signup={whatsappEmbeddedSignup}
          can_manage_resources={canManage}
        />}
        {gatewayChannels.supported && <DiscordChannelCard worker={worker} discordBots={discordBots} canManage={canManage} />}
        {worker.agent_harness === 'codex' ? <CodexSlackCard workerId={worker.id} canManage={canManage} /> : <SlackComingSoonCard />}
        {(telegram.supported || worker.telegram_bot_username) && <TelegramChannelCard worker={worker} canManage={canManage} />}
      </div>
    </section>
  )
}
